import styled from "styled-components";
import theme from "../../../assets/theme";
import { PrimaryCTAButton } from "../../common/Buttons";

export const Footer = styled.footer`
  & .highlighted {
    color: red;
    margin-top: 10px;
    font-size: 12px;
    font-family: ${theme.fonts.primaryFontSemiBold};
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex: 1;
  & .button-row {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    @media ${theme?.breakpoints?.sm_up} {
      flex-direction: row;
      justify-content: flex-end;
    }
  }
`;

export const DangerBtn = styled(PrimaryCTAButton)`
  background-color: #ff3c3c;
  &:focus,
  &:hover {
    background-color: #ff4d4d;
    border: 1px solid #ff3c3c;
  }
  border: 1px solid #ff3c3c;
`;

export const StatusBadge = styled.span`
  padding: 4px 12px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 500;
  font-family: openSans-SemiBold, sans-serif;
  background-color: ${(props) =>
    props.status === "Pending"
      ? "#fef3c7"
      : props.status === "Rejected"
      ? "#FFA4A4"
      : "#d1fae5"};
  color: ${(props) =>
    props.status === "Pending"
      ? "#92400e"
      : props.status === "Rejected"
      ? "#ffffff"
      : "#065f46"};
`;
